import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";

export const ServiceCard = ({ service, index = 0 }) => {
  const Icon = service.icon;
  return (
    <Reveal delay={(index % 4) * 0.08} className="h-full">
      <div data-testid={`service-card-${service.id}`} className="group flex h-full flex-col rounded-2xl border border-brand-light bg-white p-7 transition-all duration-300 hover:-translate-y-1.5 hover:border-brand-green/40 hover:shadow-xl hover:shadow-brand-green/10">
        <div className="flex h-13 w-13 items-center justify-center rounded-xl bg-brand-light p-3 text-brand-green transition-colors duration-300 group-hover:bg-brand-green group-hover:text-white">
          <Icon className="h-6 w-6" strokeWidth={1.9} />
        </div>
        <h3 className="mt-5 font-heading text-xl font-bold text-brand-green">{service.title}</h3>
        <p className="mt-2.5 flex-1 text-sm leading-relaxed text-brand-muted">{service.desc}</p>
        <ul className="mt-4 space-y-1.5">
          {service.points.map((p) => (
            <li key={p} className="flex items-center gap-2 text-xs font-semibold text-brand-ink/70">
              <span className="h-1 w-1 rounded-full bg-brand-red" /> {p}
            </li>
          ))}
        </ul>
        <Link
          to={`/contact?service=${service.id}`}
          data-testid={`service-quote-${service.id}`}
          className="mt-6 inline-flex items-center gap-1.5 text-sm font-bold text-brand-red transition-colors hover:text-brand-redDark"
        >
          Request a Quote <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
        </Link>
      </div>
    </Reveal>
  );
};
